import Slider from "react-slick";
import {ReactElement, useRef} from "react";
import RequestConfig from "../../../Requests/RequestConfig.json";
import {useProductListBannerAutoplay} from "./Hooks/useProductListBannerAutoplay";
import {getProductListBannerUrl} from "./helpers";
import {useProductListBanners} from "./ProductListBannersContext";
import {ProductListBanner} from "./types";

export function ProductListBannerCarousel(): ReactElement {
    const {activeSlide, bannerSetKey, banners, setActiveSlide} = useProductListBanners();
    const sliderRef = useRef<Slider | null>(null);
    const {containerRef, shouldAutoplay} = useProductListBannerAutoplay(sliderRef, banners.length > 1);

    if (banners.length === 1) {
        return (
            <div className="product-list-banners" ref={containerRef}>
                <BannerItem banner={banners[0]} />
            </div>
        );
    }

    return (
        <div className="product-list-banners" ref={containerRef}>
            <Slider
                ref={(slider: Slider | null) => {
                    sliderRef.current = slider;
                }}
                key={bannerSetKey}
                dots
                infinite
                speed={1000}
                autoplay={shouldAutoplay}
                autoplaySpeed={4000}
                initialSlide={Math.min(activeSlide, banners.length - 1)}
                slidesToShow={1}
                slidesToScroll={1}
                afterChange={(slide: number) => setActiveSlide(bannerSetKey, slide)}
            >
                {banners.map((banner) => <BannerItem key={banner.id} banner={banner} />)}
            </Slider>
        </div>
    );
}

type BannerItemProps = {
    banner: ProductListBanner;
};

function BannerItem({banner}: BannerItemProps): ReactElement {
    const imageUrl = `${RequestConfig.domain}/assets/banner/${banner.image}`;
    const image = <img className="banner" src={imageUrl} alt={banner.name} />;
    const url = typeof banner.url === "string" ? banner.url.trim() : "";
    const hasUrl = url !== "" && url !== "null" && url !== "undefined";

    return hasUrl
        ? <a href={getProductListBannerUrl(url)} aria-label={banner.name}>{image}</a>
        : image;
}
